
// export const HOMEPAGE = createRequestTypes('homepage/HOMEPAGE');
// export const SAVE_HOMEPAGE = createRequestTypes('homepage/SAVE_HOMEPAGE');
// export const DELETE_HOMEPAGE = createRequestTypes('homepage/DELETE_HOMEPAGE');
export const MERGE_HOMEPAGES = 'homepage/MERGE_HOMEPAGES';
